// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"242":"b2370ef4","4384":"9e063bfe","6096":"b2370ef4","6162":"c098f29f","6528":"b2370ef4","7823":"b2370ef4","8688":"1d5b88f4"}[chunkId] + ".chunk.css";
};